import { events } from 'aws-amplify/api';
import {
  AmplifyChannelCreatorParams,
  amplifyChannelEventExpiryTime,
  amplifyChannelNameCreators,
  AmplifyEvent,
  AmplifyEventType,
  AmplifyEventTypePayload
} from './amplifyEventTypes';
import { useUser } from 'core/stores/hooks/useUser';
import { useRef } from 'react';

export const useAmplifyPublishEvent = <T extends AmplifyEventType>(
  props?: {
    channelType: T;
    channelParams: AmplifyChannelCreatorParams[T];
  } | null
) => {
  const user = useUser();
  // NOTE: This prevents spamming of events
  const shouldDebounceRef = useRef(false);

  const publishEvent = async (
    payload: AmplifyEventTypePayload[T]
  ): Promise<void> => {
    if (!props) return;
    try {
      if (shouldDebounceRef.current) return;
      const event: AmplifyEvent<T> = {
        userId: user.id,
        eventType: props.channelType,
        payload
      } as AmplifyEvent<T>;

      const createChannelName = amplifyChannelNameCreators[event.eventType];
      const channelName = createChannelName(props.channelParams);

      // NOTE: event type isn't working correctly on amplify
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      await events.post(channelName, event as any);

      shouldDebounceRef.current = true;

      setTimeout(() => {
        shouldDebounceRef.current = false;
        // NOTE: Only publish events with half the expiryTime
      }, amplifyChannelEventExpiryTime[event.eventType] / 2);
    } catch (error) {
      console.error('Error publishing event:', error);
    }
  };

  return { publishEvent };
};
